import React, { Component } from "react";
import { FaUserTag } from "react-icons/fa";
import COLORS from "scss/colors.module.scss";
import { inject, observer } from "mobx-react";
import styled, { css } from "styled-components";

function RolesAndPermissions({ list, listColumns, listPermissions, handleClose = () => {} }) {

    return (
        <StyledPermissionsDiv 
            className="d-flex"
            onClick={() => {
                handleClose();
                var shareWin = Ext.create("TL.Window", {
                    title: "Roles & Permissions",
                    cls: "tl-window permissions-win",
                    modal: true,
                    width: 1000,
                    layout: 'fit',
                    autoScroll: true,
                    helpLinkIdentifier: "share-app",
                    items: [Ext.create("TL.list.permissions.SharePanel", {
                        autoHeight: true,
                        anchor: "100%",
                        border: false,
                        list: list,
                        listColumns: listColumns,
                        permissions: listPermissions,
                        listeners: {
                            close: function () {
                                shareWin.close();
                            },
                            scope: this
                        }
                    })],
                    listeners: {
                        'show': function () {
        
                        },
                        'close': function () {
                            setTimeout(function () {
                                TL.help.HintsService.showHints(TL.help.HintsService.EVENT_ROLE_PERMISSIONS_CLOSED, {});
                            }, 500);
                        }
                    }
                });
                shareWin.show();
            }}
        >
            <IconWrapper>
                <FaUserTag size={18} color={COLORS.TEXT_COLOR} />
            </IconWrapper>
            Sheet permissions
        </StyledPermissionsDiv>
    );
}

export default inject(({ store: appStore }) => {
    const currentListId = appStore.leftHoverMenuStore.currentListId;
    const listConfig = appStore.getCurrentListContainerStore(currentListId).listConfig    

    return ({
        list: listConfig?.list,
        listColumns: listConfig?.listData,
        listPermissions: listConfig?.listPermissions
    })
})(observer(RolesAndPermissions));

const StyledPermissionsDiv = styled.div`
  cursor: pointer;
  padding: 6px 16px;
  align-items: center;
  line-height: 20px;
  white-space: nowrap;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const IconWrapper = styled.div`
  margin-right: 15px;
`;